import lazyframe from "lazyframe";

export default () => {
  let elements = $(".video-player__lazyframe");
  let sliderViewport = $(".js-efficiency-slider-viewport");

  lazyframe(elements, {
    onAppend: iframe => {
      $(iframe).attr({
        allow: "autoplay",
        title: elements.data( "title")
      });
      if (sliderViewport.length) {
        sliderViewport.slick("slickPause");
        sliderViewport.addClass("js-player-is-on")
      }
    }
  });

  $(elements).on("keydown", function (event) {
    const keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode === 13) {
      $(this).trigger("click");
    }
  });
};

export  const handleFullscreenHelpers = () => {
  const header = $("body");

  if(!document.querySelector(".video-player-wrapper")){
    return;
  } else {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (header.length) header.addClass("frame-fulscreen");
      document.querySelector(".video-player-wrapper").classList.remove("fadeInUp")
    } else {
      header.removeClass("frame-fulscreen");
      document.querySelector(".video-player-wrapper").classList.add("fadeInUp")
    }
  }
};
